export default __webpack_public_path__ + "static/media/ipad-left-img.683d87ad.jpg";